import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDropdown, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { AppService } from '../app.service';
import { ProfileHeaderComponent } from '../common/profile-header/profile-header.component';
import { SwooshComponent } from '../common/ui-elements/swoosh.component';
import { TeamCompareComponent } from './compare/team-compare.component';
import { TeamDichotomiesComponent } from './dichotomies/team-dichotomies.component';
import { TeamInsightsComponent } from './team-insights/team-teaminsights.component';
import { TeamMembersComponent } from './team-members/team-teammembers.component';

//import 'bootstrap';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss'],
  standalone: true,
  imports: [
    SwooshComponent,
    ProfileHeaderComponent,
    NgbDropdown,
    TeamMembersComponent,
    TeamDichotomiesComponent,
    TeamCompareComponent,
    TeamInsightsComponent,
    CommonModule,
    NgbNavModule,
  ],
})
export class TeamComponent implements OnInit {
  active: any;
  chosenDropDown = 'Team Members';
  showTeamMembers = true;
  showDichotomies = false;
  showCompare = false;
  showTeamInsights = false;
  isDesktopLayout: boolean;
  private forwardTarget: string = '';
  private fragment: string;
  swooshText = '';
  swooshExternal = '';

  constructor(
    private appService: AppService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
    this.isDesktopLayout = window.innerWidth >= 768;
    this.forwardTarget = this.activatedRoute.snapshot.queryParamMap.get('target');
    this.fragment = activatedRoute.snapshot.fragment;
  }

  ngOnInit() {
    if (this.forwardTarget) {
      this.router.navigateByUrl(this.forwardTarget, { replaceUrl: true });
    }

    this.activatedRoute.queryParams.subscribe((data) => {
      if (data['memberId'] > 0) {
        console.log('memberId: ' + data['memberId']);
        this.selectContent('Compare');
      }
    });
    window.onresize = () => (this.isDesktopLayout = window.innerWidth >= 768);

    // ex. link to /teams/#TeamInsights
    if (this.fragment) this.selectContent(this.fragment);

    if (this.appService.getTeamInfo().isElevateTeam) {
      this.swooshText = 'Back to Your Elevate Dashboard';
      this.swooshExternal = this.appService.getTeamInfo().redirectUrl;
    }
  }

  selectContent(id) {
    this.showTeamMembers = false;
    this.showDichotomies = false;
    this.showCompare = false;
    this.showTeamInsights = false;

    this.active = id;

    switch (id) {
      case 'TeamMembers': {
        this.showTeamMembers = true;
        this.chosenDropDown = 'Team Members';
        break;
      }
      case 'Dichotomies': {
        this.showDichotomies = true;
        this.chosenDropDown = 'Preference Pairs';
        break;
      }
      case 'Compare': {
        this.showCompare = true;
        this.chosenDropDown = 'Compare';
        break;
      }
      case 'TeamInsights': {
        this.showTeamInsights = true;
        this.chosenDropDown = 'Team Insights';
        break;
      }
      default: {
        //statements;
        this.showTeamMembers = !this.isShowingEmptyState();
        this.active = 'TeamMembers';
        this.chosenDropDown = 'Team Members';
        break;
      }
    }
  }

  isShowingEmptyState() {
    return this.appService.isShowingEmptyState();
  }
}
